// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  CanonicalAddress,
  TtwPitchVideoKindV1,
  TtwVideoProviderV1,
  TtwPageStageV1,
  AdminTtwHighlight,
  AdminTtwKeyStat,
} from "./types";


export default __t.row({
  id: __t.uuid(),
  shareableBusinessCard: __t.uuid().name("shareable_business_card"),
  cardIsLive: __t.bool().name("card_is_live"),
  cardIsAccessProtected: __t.bool().name("card_is_access_protected"),
  brandFriendlyName: __t.option(__t.string()).name("brand_friendly_name"),
  ownerEmail: __t.option(__t.string()).name("owner_email"),
  get targetPropertyAddress() {
    return __t.option(CanonicalAddress).name("target_property_address");
  },
  featureImage: __t.string().name("feature_image"),
  get pitchVideoKind() {
    return TtwPitchVideoKindV1.name("pitch_video_kind");
  },
  pitchVideoValue: __t.option(__t.string()).name("pitch_video_value"),
  get pitchVideoProvider() {
    return __t.option(TtwVideoProviderV1).name("pitch_video_provider");
  },
  businessName: __t.string().name("business_name"),
  category: __t.string(),
  targetProperty: __t.option(__t.uuid()).name("target_property"),
  showNominator: __t.bool().name("show_nominator"),
  showTotalReserved: __t.bool().name("show_total_reserved"),
  showAppreciationShare: __t.bool().name("show_appreciation_share"),
  get highlights() {
    return __t.array(AdminTtwHighlight);
  },
  stewardImage: __t.option(__t.string()).name("steward_image"),
  stewardQuote: __t.option(__t.string()).name("steward_quote"),
  stewardAttribution: __t.option(__t.string()).name("steward_attribution"),
  stewardAbout: __t.option(__t.string()).name("steward_about"),
  get keyStats() {
    return __t.array(AdminTtwKeyStat).name("key_stats");
  },
  realEstateAbout: __t.option(__t.string()).name("real_estate_about"),
  targetArea: __t.option(__t.string()).name("target_area"),
  gallery: __t.array(__t.string()),
  propertyType: __t.option(__t.string()).name("property_type"),
  stories: __t.option(__t.string()),
  yearBuilt: __t.option(__t.string()).name("year_built"),
  propertySqft: __t.option(__t.i32()).name("property_sqft"),
  showEstimatedValueChart: __t.bool().name("show_estimated_value_chart"),
  catalogPropertySqft: __t.option(__t.f64()).name("catalog_property_sqft"),
  sharePriceCents: __t.i64().name("share_price_cents"),
  totalShares: __t.i64().name("total_shares"),
  targetReturnBps: __t.i32().name("target_return_bps"),
  targetReturnBpsMax: __t.i32().name("target_return_bps_max"),
  targetRaiseCents: __t.i64().name("target_raise_cents"),
  get stage() {
    return TtwPageStageV1;
  },
  appreciationShareBps: __t.i32().name("appreciation_share_bps"),
});
